import { toast } from 'sonner';
import { createTask, Task, TaskCommand, waitforTask } from './task';

type TaskResultWithError = { ip: string; status: string; error?: string };

/** Loads a guide on the given TVs through the agent and reports per-TV
 *  outcomes. The agent records the loaded version on each TV it reaches. */
export async function pushGuide(
  channelGuideId: string,
  ips: string[],
  label: string
) {
  if (!ips.length) {
    toast.info(`${label}: no TVs to load`);
    return;
  }
  const taskId = await createTask({
    boxes: ips,
    // ZeeVee commands are not in the box TaskCommand enum
    command: 'LOAD_CHANNEL_GUIDE' as unknown as TaskCommand,
    isTvControllerTask: true,
    data: { channelGuideId },
  });
  const summary = (task?: Task) => {
    const results = (task?.results || []) as TaskResultWithError[];
    const failed = results.filter((r) => r.status === 'FAILED');
    return failed.length
      ? `${label}: loaded on ${results.length - failed.length} of ${ips.length} TV(s); failed on ${failed
          .map((r) => r.ip)
          .join(', ')}`
      : `${label}: loaded on ${ips.length} TV(s)`;
  };
  toast.promise(waitforTask(taskId), {
    loading: `${label}: loading on ${ips.length} TV(s)...`,
    success: (task) => summary(task),
    error: (error) =>
      error?.task
        ? summary(error.task)
        : `${label}: ${error?.message ?? 'failed'}`,
  });
}
